import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const FinanceSupplierEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});


  useEffect(() => {
        setPermission(FindModuleById(459)); 
console.log(permission);

    axios
      .get(`/financessuppliers/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        //setBackendErrors(response.data.data.supplier);
        setValue(response.data.data.supplier);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      name: value.name,
  
      if: value.if,
      ice: value.ice,
      expense_type:value.expense_type
  
    },
    enableReinitialize: true,
    onSubmit: (values,{ setSubmitting })=> {
      axios
        .post("/financessuppliers/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Update Supplier");
          if (response.data.code === 200) {
            toast.success(response.data.message);
          
            setTimeout(() => {
              window.location.href = "/financessuppliers";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


 
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Suppliers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/financessuppliers">Suppliers</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Supllier </h4>
                    {permission?.update == 1 && (
                          <FormikProvider value={formik}>
                          <form action="#" onSubmit={formik.handleSubmit}>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                name="name"
                                value={formik.values.name}
                                className={
                                  backendErrors.name
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.name && (
                                  <span className="form-error mt-1">
                                    {backendErrors.name}
                                  </span>
                                )}
                              </small>
                            </div>
                          
                          </div>
                        
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>IF</label>
                              <input
                                type="text"
                                name="if"
                                onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9]$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                value={formik.values.if}
                                className={
                                  backendErrors.if
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            <small>
                                {backendErrors.if && (
                                  <span className="form-error mt-1">
                                    {backendErrors.if}
                                  </span>
                                )}
                              </small>
                            </div>
                          
                          </div>
                          
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>ICE</label>
                              <input
                                type="text"
                                name="ice"
                                onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9]$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                value={formik.values.ice}
                                className={
                                  backendErrors.ice
                                    ? "form-input form-control input-error"
                                    : "form-input form-control"
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            <small>
                                {backendErrors.ice && (
                                  <span className="form-error mt-1">
                                    {backendErrors.ice}
                                  </span>
                                )}
                              </small>
                            </div>
                          
                          </div>
  <div className="col-md-6">
                              <div className="form-group">
                                <label>Expense Type</label>
                                <input
                                  type="text"
                                  name="expense_type"
                                 
                                  value={formik.values.expense_type}
                                  className={
                                    backendErrors.expense_type
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                />
                              <small>
                                  {backendErrors.expense_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.expense_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            
                            </div>

                        </div>
                        <small>
                                {backendErrors.status  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.status}
                                  </span>
                                )}

                            
                              </small>
                        <div className="text-end mt-4">
                          <button
                            type="submit" id="form-submit"
                            className="btn btn-primary"
                            disabled={formik.isSubmitting}
                          >
                            Update Supplier
                          </button>
                        </div>
                        </form>
                        </FormikProvider>
                    )}

                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FinanceSupplierEdit;
